import React from "react";

const AchievementsPage = ({ username, clickCount, userAchievements, achievements }) => {
  return (
    <div className="container_">
      <h1>Ваши достижения</h1>
      <div className="achievements-grid">
        {achievements.map((achievement) => {
          const progress = Math.min(clickCount / achievement.condition, 1); // Прогресс выполнения
          const isUnlocked = userAchievements.includes(achievement.id); // Проверка, открыта ли ачивка
          const progressPercentage = Math.floor(progress * 100);

          return (
            <div
              key={achievement.id}
              className={`achievement-card ${isUnlocked ? "unlocked" : ""}`}
            >
              <div className="sborik">
              <img src="sads.png" alt="" />
              <div className="group">
                <div className="info_row">{achievement.name}</div>
                <div className="info_row_sub_cnt">{achievement.description}</div>
              </div>
              <div className="unlk">
                Награда: <p>{achievement.reward}</p>
              </div>
              </div>
              {/* Слайдер прогресса */}
              <div className="progress-container">
                <div className="progress-barich">
                  <div
                    className="progress-filled"
                    style={{ width: `${progressPercentage}%` }}
                  ></div>
                </div>
                <span className="progress-texted">
                  {Math.min(clickCount, achievement.condition)}/
                  {achievement.condition}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AchievementsPage;
